{
  "toast": {
    "automationCreated": "Automation created",
    "actionAdded": "Action added",
    "boardCreated": "Board created",
    "dependencyAdded": "Dependency added",
    "issueCreated": "Issue created",
    "projectArchived": "Project archived",
    "projectCloned": "Project cloned",
    "projectCreated": "Project created",
    "ifRegisteredALoginLinkWasSentTo": "If registered, a login link was sent to your email",
    "signedIn": "Signed in",
    "portfolioCreated": "Portfolio created",
    "resourceAllocated": "Resource allocated",
    "documentUploaded": "Document uploaded",
    "projectCreatedFromTemplate": "Project created from template",
    "clientPortalUserCreated": "Client portal user created",
    "sprintStarted": "Sprint started",
    "sprintCompleted": "Sprint completed",
    "taskAddedToSprint": "Task added to sprint",
    "taskUpdated": "Task updated",
    "taskCreated": "Task created",
    "taskDeleted": "Task deleted",
    "timeLogged": "Time logged",
    "timesheetApproved": "Timesheet approved",
    "timesheetRejected": "Timesheet rejected",
    "timesheetSubmitted": "Timesheet submitted",
    "projectCompleted": "Project completed",
    "reportExported": "{{reportType}} exported",
    "financeInvoiceCreated": "Finance invoice {{invoiceNumber}} created ({{lineCount}} lines)",
    "tasksSynced": "Synced {{count}} tasks to board"
  },
  "errors": {
    "failedToLoadAutomations": "Failed to load automations",
    "failedToLoadActions": "Failed to load actions",
    "createFailed": "Create failed",
    "updateFailed": "Update failed",
    "addActionFailed": "Add action failed",
    "failedToLoadBoards": "Failed to load boards",
    "failedToLoadBoard": "Failed to load board",
    "createBoardFailed": "Create board failed",
    "syncFailed": "Sync failed",
    "moveFailed": "Move failed",
    "failedToLoadCalendar": "Failed to load calendar",
    "enterBothTaskIds": "Enter both task IDs",
    "failedToLoadGantt": "Failed to load Gantt",
    "addDependencyFailed": "Add dependency failed",
    "archiveFailed": "Archive failed",
    "cloneFailed": "Clone failed",
    "requestFailed": "Request failed",
    "verificationFailed": "Verification failed",
    "budgetLoadFailed": "Budget load failed",
    "reportsUnavailable": "Reports unavailable",
    "exportFailed": "Export failed",
    "failedToLoadResources": "Failed to load resources",
    "allocateFailed": "Allocate failed",
    "failedToLoadTemplates": "Failed to load templates",
    "uploadFailed": "Upload failed",
    "instantiateFailed": "Instantiate failed",
    "portalInviteFailed": "Portal invite failed",
    "backlogLoadFailed": "Backlog load failed",
    "startSprintFailed": "Start sprint failed",
    "completeSprintFailed": "Complete sprint failed",
    "assignFailed": "Assign failed",
    "selectAProject": "Select a project",
    "deleteFailed": "Delete failed",
    "enterBillingDateRange": "Enter billing date range",
    "logTimeFailed": "Log time failed",
    "billTimeFailedEnsureFinanceModuleAndBillable": "Bill time failed — ensure Finance module and billable hours exist",
    "submitFailed": "Submit failed",
    "timesheetApprovalFailed": "Timesheet approval failed",
    "timesheetRejectionFailed": "Timesheet rejection failed",
    "projectCompletionFailed": "Project completion failed",
    "analyticsUnavailable": "Analytics unavailable",
    "failedToLoadIssues": "Failed to load issues",
    "failedToLoadProjects": "Failed to load projects",
    "failedToLoadPortfolios": "Failed to load portfolios",
    "failedToLoadSprints": "Failed to load sprints",
    "failedToLoadTasks": "Failed to load tasks",
    "failedToLoadTimesheets": "Failed to load timesheets"
  },
  "pages": {
    "automation": "Automation",
    "createAutomation": "Create automation",
    "addWorkflowAction": "Add workflow action",
    "workflowTriggersAndActionsForTasks": "Workflow triggers and actions for tasks and sprints",
    "boards": "Boards",
    "createBoard": "Create board",
    "kanbanBoardsWithDragAndDrop": "Kanban boards with drag-and-drop, WIP limits, and workflow columns",
    "calendar": "Calendar",
    "milestonesAndTaskDueDates": "Milestones and task due dates",
    "projectsDashboard": "Projects Dashboard",
    "deliveryDetails": "Delivery details",
    "tasks": "Tasks",
    "issues": "Issues",
    "activeSprints": "Active Sprints",
    "deliveryHealthAcrossProjectsTasksIssues": "Delivery health across projects, tasks, issues, and sprints in your scope",
    "gantt": "Gantt",
    "timelineViewWithDependenciesAndCritical": "Timeline view with dependencies and critical path",
    "createIssue": "Create issue",
    "bugsAndDeskTicketEscalationsAuto": "Bugs and Desk ticket escalations (auto-linked from Desk)",
    "projects": "Projects",
    "createProject": "Create project",
    "portfolioOfClientAndInternalDelivery": "Portfolio of client and internal delivery projects",
    "projectClientPortal": "Project client portal",
    "verifyLogin": "Verify login",
    "viewYourProjectStatusTasksDocuments": "View your project status, tasks, documents, and invoices",
    "completeClientPortalSignIn": "Complete client portal sign-in",
    "pmoPortfolio": "PMO & Portfolio",
    "createPortfolio": "Create portfolio",
    "executiveDashboardPortfoliosAndProjectBudget": "Executive dashboard, portfolios, and project budget health",
    "projectReports": "Project Reports",
    "deliveryAnalyticsAndExportableReports": "Delivery analytics and exportable reports",
    "resourcePlanning": "Resource planning",
    "teamAllocationAndCapacityByProject": "Team allocation and capacity by project",
    "projectSetup": "Project Setup",
    "templatesClientPortalAndConfiguration": "Templates, client portal, and configuration",
    "pdfWordExcelOrImages": "PDF, Word, Excel, or images",
    "sprints": "Sprints",
    "startSprint": "Start sprint",
    "backlogSprintPlanningExecutionAndVelocity": "Backlog, sprint planning, execution, and velocity",
    "createTask": "Create task",
    "editTask": "Edit task",
    "edit": "Edit",
    "delete": "Delete",
    "hierarchicalTasksWithCreateEditAnd": "Hierarchical tasks with create, edit, and delete",
    "timesheets": "Timesheets",
    "logTime": "Log time",
    "submitTimesheet": "Submit timesheet",
    "logTimeSubmitWeeklyTimesheetsAnd": "Log time, submit weekly timesheets, and approve hours",
    "workload": "Workload",
    "activeProjects": "Active projects",
    "taskCompletion": "Task completion",
    "loggedHoursMonth": "Logged hours (month)",
    "sprintVelocity": "Sprint velocity",
    "resourceUtilizationAndCapacityPlanning": "Resource utilization and capacity planning",
    "billApprovedTimeToFinance": "Bill approved time to Finance",
    "createsFinanceInvoiceFromBillableTimeEntries": "Creates a Finance invoice from billable time entries in the date range (`ProjectTimeBillingService`).",
    "roleDashboards": "Role dashboards",
    "openIssues": "Open issues",
    "billingQueue": "Billing queue",
    "budgetUtilization": "Budget utilization",
    "seePortfolio": "See portfolio",
    "profitability": "Profitability",
    "allocationConflicts": "Allocation conflicts",
    "capacityRecords": "Capacity records",
    "visibleDocuments": "Visible documents",
    "milestones": "Milestones",
    "portal": "Portal",
    "project360": "Project 360",
    "loadingProject": "Loading project",
    "workBreakdownStructure": "Work breakdown structure",
    "recentTasks": "Recent tasks",
    "milestonesAndDeliverables": "Milestones and deliverables",
    "recentActivity": "Recent activity",
    "documents": "Documents",
    "sourceAndPlanningTraceability": "Source and planning traceability"
  },
  "labels": {
    "ruleName": "Rule name",
    "triggerEvent": "Trigger event",
    "actionType": "Action type",
    "boardCode": "Board code",
    "boardName": "Board name",
    "selectProject": "Select project",
    "taskId": "Task ID",
    "dependsOnTaskId": "Depends on task ID",
    "dependencyType": "Dependency type",
    "lagDays": "Lag days",
    "dependsOn": "Depends on",
    "baseline": "Baseline",
    "forecast": "Forecast",
    "slackDays": "Slack: {{count}} days",
    "criticalPath": "Critical path",
    "title": "Title",
    "description": "Description",
    "projectCode": "Project code",
    "projectName": "Project name",
    "projectType": "Project type",
    "budget": "Budget",
    "lifecycle": "Lifecycle",
    "expectedCost": "Expected cost",
    "currency": "Currency",
    "startDate": "Start date",
    "endDate": "End date",
    "timezone": "Timezone",
    "warrantyEndDate": "Warranty end date",
    "tagsJson": "Tags JSON",
    "creationSource": "Creation source",
    "source": "Source",
    "sourceId": "Source ID",
    "organizationId": "Organization ID",
    "email": "Email",
    "token": "Token",
    "code": "Code",
    "name": "Name",
    "allocation": "Allocation %",
    "clientEmail": "Client email",
    "uploadDocument": "Upload document",
    "sprintCode": "Sprint code",
    "sprintName": "Sprint name",
    "goal": "Goal",
    "backlogProject": "Backlog project",
    "productBacklogWithCount": "Product backlog ({{count}})",
    "taskNumber": "Task #{{id}}",
    "allProjects": "All projects",
    "project": "Project",
    "velocity": "Velocity",
    "date": "Date",
    "hours": "Hours",
    "employee": "Employee",
    "weekStart": "Week start",
    "weekEnd": "Week end",
    "status": "Status",
    "actions": "Actions",
    "task": "Task",
    "type": "Type",
    "assignee": "Assignee",
    "due": "Due",
    "estimatedHours": "Est. hours",
    "actualHours": "Actual hours",
    "expectedRevenue": "Expected revenue",
    "actualCost": "Actual cost",
    "milestone": "Milestone",
    "target": "Target",
    "deliverable": "Deliverable",
    "documentNumber": "Document #{{id}}",
    "folder": "Folder",
    "category": "Category",
    "version": "Version",
    "customerVisible": "Customer visible",
    "estimatedShort": "Est",
    "actualShort": "Actual",
    "customerId": "Customer ID",
    "opportunityDealId": "Opportunity/Deal ID",
    "quotationId": "Quotation ID",
    "salesOrderId": "Sales order ID",
    "managerId": "Manager ID",
    "ownerId": "Owner ID",
    "departmentId": "Department ID",
    "businessUnitId": "Business unit ID",
    "projectManagerId": "Project manager ID",
    "ownerEmployeeId": "Owner employee ID",
    "start": "Start",
    "end": "End",
    "warrantyEnd": "Warranty end"
  },
  "formActions": {
    "submitWeek": "Submit week"
  },
  "listActions": {
    "newProject": "New project",
    "view": "View",
    "archive": "Archive",
    "clone": "Clone",
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save",
    "delete": "Delete",
    "addDependency": "Add dependency",
    "newBoard": "New board",
    "syncTasks": "Sync tasks",
    "newPortfolio": "New portfolio",
    "newTask": "New task",
    "newIssue": "New issue",
    "newRule": "New rule",
    "logTime": "Log time",
    "startSprint": "Start sprint",
    "start": "Start",
    "useTemplate": "Use",
    "grantPortalAccess": "Grant portal access",
    "sendMagicLink": "Send magic link",
    "approve": "Approve",
    "reject": "Reject",
    "billToFinance": "Bill to Finance",
    "back": "Back",
    "complete": "Complete"
  },
  "dependencyTypes": {
    "finishToStart": "Finish to start",
    "startToStart": "Start to start",
    "finishToFinish": "Finish to finish",
    "startToFinish": "Start to finish"
  },
  "sourceModes": {
    "manual": "Manual",
    "deal": "CRM Opportunity/Deal",
    "quote": "Sales Quotation"
  },
  "dialogs": {
    "deleteTaskTitle": "Delete task",
    "deleteTaskMessage": "This task will be permanently removed."
  },
  "status": {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "tracked": "Tracked",
    "guarded": "Guarded",
    "enabled": "Enabled",
    "restricted": "Restricted",
    "yes": "Yes",
    "no": "No"
  },
  "personas": {
    "executive": "Executive",
    "pm": "Project manager",
    "team": "Team",
    "resource": "Resource",
    "finance": "Finance",
    "customer": "Customer"
  },
  "empty": {
    "noRecentProjectActivity": "No recent project activity.",
    "noProjectDocumentsYet": "No project documents yet.",
    "noWbsTasksYet": "No WBS tasks yet.",
    "noTasksWithDates": "No tasks with dates for this project."
  }
}
